module.exports = __webpack_public_path__ + "assets/assets/images/intake/people.f2d125e1.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/intake/people.png
// module id = 397
// module chunks = 0